import { Grid } from '@mui/material';
import { MotionText } from '@shared/atoms';
import { LearningArticleCard, LearningCarousel } from '@shared/molecules';
import React from 'react';
import { useHistory } from 'react-router';
import styles from './styles.module.scss';

interface SectionProps {
  learningPosts: { id: number; innerImageUrl: string; title: string }[];
  loadingPosts: boolean;
}

export const RecommendedLearningsSection: React.FC<SectionProps> = ({
  learningPosts,
  loadingPosts,
}) => {
  const history = useHistory();

  const handleNavigate = (id: number, title: string) => {
    history.push(`/post/${id}`);
  };

  return (
    <div className={styles.learningContainer}>
      <div className={styles.topContainer}>
        <MotionText
          id="learnings-heading"
          as="h3"
          text="Quick Calm & Support"
          className={styles.sectionTitle}
        />
      </div>

      {/* <MotionText
        as="text"
        text="DESCRIPTION IF HAVE"
        className={styles.sectionDescription}
      /> */}

      <div className={styles.learningItemsContainer}>
        <LearningCarousel
          data={learningPosts}
          loading={loadingPosts}
          carouselType="categoryPosts"
          navigate={handleNavigate}
        />
      </div>
    </div>
  );
};
